import { NavItemEnum } from './NavItems';
export default Object.assign({}, NavItemEnum, {
  LEGACY_STARTER_CONFIRMATION: 'legacy-starter-confirmation',
  CONFIRM_CONTACTS: 'confirm-contacts',
  COMPARE: 'feature-compare',
  SPLASH: 'splash',
  INTERSTITIAL: 'interstitial',
  SUITE_STARTER: 'suite-starter'
});